import React from 'react'
import {injectIntl} from 'react-intl'
import {withTranslation} from 'react-i18next'
import {Loading} from '../../components/shared/Loading'
import { compose } from 'redux'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import { searchRoster } from '../../data/rosterStreams'
import { useHistory, useRouteMatch, Link as RouterLink } from 'react-router-dom'
import {imageStyles } from '../../shared/styles';
import { styles } from './styles'
import { ProfileRenderer } from '../../components/eventRoster/ProfileRenderer'
import { Select, Grid, TextField, IconButton, InputLabel, InputAdornment, Portal, Link } from '@material-ui/core'
import { StandardTable, Cell } from '../../components/shared/tables/Table'
import { SearchIcon } from '../../components/shared/icons'
import { toNameCase } from '../../utils/stringUtils'
import { Pager } from '../../components/shared/Pager'
// import { hasBetaAccess } from '../../utils/isLoggedIn'

export const EventRosterViewComponent = ({
  races,
  isMobile,
  t,
  intl,
}) => {
  const route = useRouteMatch()
  const {
    masterId: $masterId,
    eventId: $eventId,
    courseId: $eventCourseId,
  } = route.params
  let masterId = parseInt($masterId) ?? undefined
  let eventId = parseInt($eventId) ?? undefined
  let eventCourseId = parseInt($eventCourseId) ?? undefined
  // console.log({eventId, eventCourseId, route})
  if (!eventId && races?.length) {
    // console.log('Guess eventId is missing...', eventId)
    eventId = races.reduce((a, c, i) => {
      if (c.isCurrentRace) {
        return c.raceID
      }
      else if (!a) {
        return c
      }
      return a
    }, 0)
  }
  if (!eventCourseId && races?.length && eventId) {
    eventCourseId = races.find((x) => x.raceID === eventId)?.eventCourses[0]?.eventCourseID
  }

//  console.log({eventCourseId, eventId})

  const history = useHistory()
  const currentUrl = new URL(window.location.href)
  const termInput = React.useRef()
  const eventSelect = React.useRef()
  const eventCourseSelect = React.useRef()
  const [isSearching, setIsSearching] = React.useState(false)

  const setEventCourseId = (ecid) => {
    pushHistory({ecid, _page: 1})
  }

  const setEventId = (evid) => {
    pushHistory({evid, _page: 1})
  }


  const searchTerm = currentUrl.searchParams.get('term')
  const [term, _setTerm] = React.useState(searchTerm)
  const setTerm = ($term) => {
    const _t = typeof $term === undefined
      ? undefined
      : `${$term}`.trim().length
        ? `${$term}`.trim()
        : null
    if (_t !== term) {
      _setTerm(_t)
      pushHistory({_term: _t, _page: 1})
    }
  }
  React.useMemo(() => _setTerm(searchTerm), [searchTerm])

  const page = parseInt(currentUrl.searchParams.get('page') || 1, 10)

  const pageSize = parseInt(currentUrl.searchParams.get('pageSize'), 10) || 50

  // const [pageSize, setPageSize] = React.useState(parseInt(currentUrl.searchParams.get('pageSize'), 10) || 50)
  // const setPageSize = (p) => {
  //   setPageSize(Math.max(50, p))
  //   setPage(0)
  //   pushHistory({_pageSize: Math.max(1, p)})
  // }

  const [roster, _setRoster] = React.useState(null)
  const setRoster = (x) => {
    setIsSearching(false)
    _setRoster(x)
  }

  const [error, _setError] = React.useState(null)
  const setError = (x) => {
    setIsSearching(false)
    _setError(x)
  }

  const getEventCourses = React.useCallback(
    () => races?.find((x) => x.raceID === eventId)?.eventCourses,
    [races, eventId])
  const getEventCourse = React.useCallback(
    () => getEventCourses()?.find((x) => x.eventCourseID === eventCourseId),
    [getEventCourses, eventCourseId])
  // console.log('races', {eventId, eventCourseId, races, courses: getEventCourses()})

  const pushHistory = React.useCallback(({_page, _term, _pageSize, evid, ecid}) => {
    const base = new URL(window.location.href)
    // Path params:
    // '/event/:masterId/roster/Event/:eventId/Course/:courseId'
    const route = ['event', masterId, 'roster']
    if (evid) {
      route.push('Event', evid)
    }
    else if (ecid) {
      route.push('Event', eventId, 'Course', ecid)
    }
    else {
      route.push('Event', eventId, 'Course', eventCourseId)
    }
    base.pathname = '/' + route.join('/')

    const q = {
      page: (_page || page),
      term: _term === null ? _term : _term ? _term : term,
      pageSize: _pageSize || pageSize,
    }
    Object.keys(q).forEach((x) => {
      // console.log('Setting', x, q[x])
      if (q[x] && `${q[x]}`.trim().length) {
        base.searchParams.set(x, `${q[x]}`.trim())
      }
      else {
        base.searchParams.delete(x)
      }
    })
    // console.log('setting url', `${base.pathname}${base.search}`)
    history.push(`${base.pathname}${base.search}`)
  }, [masterId, eventId, eventCourseId, history, page, pageSize, term])

  React.useLayoutEffect(() => {
    let mounted = true
    const fetchRoster = async () => {
      try {
        if (mounted) {
          setIsSearching(true)
//          console.log('searchRoster', {eventCourseId, term, page, pageSize})
          const r = await searchRoster({eventCourseId, term, page, pageSize})
          if (mounted) {
            setRoster(r)
          }
        }
      }
      catch (e) {
        setError(e)
      }
    }
    fetchRoster()
    return () => mounted = false
  }, [eventCourseId, term, page, pageSize])

  const Page = ({children}) => (
    <div className="container">
      <div style={isMobile ? styles.contentCardMobile : styles.contentCard}>
        <Grid container direction="row">
          <Grid item md={8} xs={12}>
            <h2>{t('Roster')}</h2>
          </Grid>
          <Grid item md={4} xs={12} style={{padding: 16}}>
            <Grid item xs={12} container direction="row">
              <TextField fullWidth
                autoComplete={'off'}
                autoCorrect={'off'}
                placeholder={t('Search by bib, name or team')}
                defaultValue={term} inputRef={termInput}
                variant="outlined"
                inputProps={{id: 'athlete-search-input'}}
                InputProps={{
                  endAdornment: term && term.length ? (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="clear search input"
                        onClick={() => {
                          termInput.current.value = ''
                          setTerm('')
                        }}
                        edge="end"
                      >
                        <HighlightOffIcon />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
                onKeyPress={(ev) => {
                  if (ev.key === 'Enter') {
                    ev.preventDefault()
                    setTerm(termInput.current.value)
                    ev.target.blur()
                  }
                }}
              />
            </Grid>
          </Grid>
          {children}
        </Grid>
      </div>
    </div>
  )

  if ((!roster && !error)) {
    return (
      <Page>
        <Portal>
          <div style={styles.loaderContainer}>
            <div style={imageStyles.loadingPosition}>
              <Loading timeoutMessage={t('Still thinking...')}/>
            </div>
          </div>
        </Portal>
      </Page>
    )
  }
  if (error) {
    console.error(error)
    return (
      <Page>
        <div>Error</div>
      </Page>
    )
  }

  // const goToARP = (ev, data, index) => {
  //   ev.preventDefault()
  //   // if (hasBetaAccess('beta-roster' && data?.entryUniqueId)) {
  //   //   history.push(`/entry/${data.entryUniqueId.toLowerCase()}`)
  //   // }
  // }

  const profileColumnRenderer = (x, i) => {
    const rowUrl = /* hasBetaAccess('beta-roster') ? `/entry/${x.entryUniqueId?.toLowerCase()}` : */ null
    const gender = x.athlete?.gender === 'male' ? 'M'
      : x.athlete?.gender === 'female' ? 'F'
      : 'U'
    const teamUrl = () => {
      if (x.team && x.team.trim().length) {
        const u = new URL(window.location.href)
        u.searchParams.set('term', x.team)
        u.searchParams.set('page', 1)
        u.searchParams.set('pageSize', pageSize)
        return u.pathname + u.search
      }
      return undefined
    }
    return (
      <Cell key={'profile-cell' + i} align="left">
        <ProfileRenderer
          age={x.athlete?.age}
          avatarUrl={x.athlete.avatarUrl}
          bib={x.bib}
          city={x.location?.address?.addressLocality}
          country={x.location?.address?.addressCountry}
          displayName={!!x.athlete?.isPrivate ? toNameCase(t('Unknown Racer')) : toNameCase(x.athlete?.displayName || t('Unknown Racer'))}
          gender={gender}
          href={rowUrl}
          isMember={x.athlete?.isMember}
          isPrivate={!!x.athlete?.isPrivate}
          racerId={x.athlete?.racerId}
          region={x.location?.address?.addressRegion}
          team={x.team}
          teamLink={teamUrl()}
          useItemScope
        />
      </Cell>
    )
  }

  const locationColumnRenderer = (x, i) => {
    const location = [
      toNameCase(x.location?.address?.addressLocality),
      x.location?.address?.addressRegion?.toUpperCase(),
      x.location?.address?.addressCountry?.toUpperCase(),
    ].filter((j) => {
      const isNumeric = !isNaN(parseInt(j))
      return !!j && !isNumeric
    })
    .join(', ')

    return (
      <Cell key={'location-cell' + i} align="right">
        <address itemProp={'homeLocation'}>{location}</address>
      </Cell>
    )
  }

  const teamRenderer = (x, i) => {
    const teamUrl = () => {
      if (x.team && x.team.trim().length) {
        const u = new URL(window.location.href)
        u.searchParams.set('term', x.team)
        u.searchParams.set('page', 1)
        u.searchParams.set('pageSize', pageSize)
        return u.pathname + u.search
      }
      return undefined
    }
    return (
      <Cell key={'team-cell' + i} align="center">
        {teamUrl() ? (
          <Link component={RouterLink} to={teamUrl()}>{x.team}</Link>
        ) : '--'}
      </Cell>
    )
  }

  const columns = isMobile ? [
      {
        label: t('Athlete'),
        key: profileColumnRenderer
      },
      // {
      //   label: t('Location'),
      //   key: locationColumnRenderer,
      // },
    ] :
    [
      {
        label: t('Athlete'),
        key: profileColumnRenderer
      },
      {
        label: t('Bib'),
        key: 'bib',
        itemProp: 'identifier',
      },
      {
        label: t('Age'),
        key: (x, i) => !!x.athlete?.age ? x.athlete.age : '--',
      },
      {
        label: t('Gender'),
        key: (x, i) => x.athlete?.gender === 'male' ? 'M' : x.athlete?.gender === 'female' ? 'F' : 'U',
        itemProp: 'gender',
      },
      {
        label: t('Team'),
        key: teamRenderer,
        itemProp: 'team',
      },
      {
        label: t('Location'),
        key: locationColumnRenderer,
      }
    ]

  const searchResultMessage = () => {
    const msg = {
      id: 'roster.results',
      defaultMessage: term ?
        `There {numResults, plural,
            =0 {are no athletes}
            =1 {is 1 athlete}
            other {are # athletes}
        } matching "${term}".` :
        `There {numResults, plural,
          =0 {are no athletes}
          =1 {is 1 athlete}
          other {are # athletes}
        } registered for this race.`,
      description:'',
    }
    return intl.formatMessage(msg, {numResults: roster.totalResults ?? 0})
  }

  return (
    <Page>
      <Grid container direction="row">
        <Grid item md={6} xs={12} style={{padding: 16}}>
          <InputLabel htmlFor="event-select">{t('Race Date')}</InputLabel>
          <Select defaultValue={eventId} fullWidth native
            ref={eventSelect}
            onChange={(ev) => setEventId(ev.target.value)}
            inputProps={{ id: 'event-select' }}
            >
            {races?.sort((first, second) => {
              const fdate = Date.parse(first.raceDate)
              const sdate = Date.parse(second.raceDate)
              return fdate > sdate ? 1 : sdate > fdate ? -1 : 0
            }).map((x) => (
              <option key={x.raceID} value={x.raceID}>{new Date(x.raceDate).toLocaleDateString()}</option>
            ))}
          </Select>
        </Grid>
        <Grid item md={6} xs={12} style={{padding: 16}}>
          <InputLabel htmlFor="course-select">{t('Course')}</InputLabel>
          <Select defaultValue={eventCourseId} fullWidth native
            ref={eventCourseSelect}
            onChange={(ev) => setEventCourseId(ev.target.value)}
            inputProps={{ id: 'course-select' }}
            >
            {getEventCourses()?.map((x) => (
              <option key={x.eventCourseID} value={x.eventCourseID}>{x.courseName}</option>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12}>
          {!isSearching && (
            <>
              <h3>{getEventCourse()?.courseName}</h3>
              <div style={styles.detailRow}>
                {searchResultMessage()}
              </div>
            </>
          )}
        </Grid>
        { !isSearching && roster?.results?.length > 0 ? (
          <>
            <Grid item xs={12}>
              <StandardTable
                columns={columns}
                // onRowClick={goToARP}
                // tableStyles={{row: {cursor: 'pointer'}}}
                dataSource={roster.results}
                itemScopeType={'http://schema.org/Person'}
                itemProp={'attendees'}
              />
            </Grid>
            <Grid item xs={12} container justify={'center'} style={{marginTop: 16}}>
              <Pager
                pageNumber={page} // zero based
                pageSize={pageSize}
                total={roster.totalResults}
                />
            </Grid>
          </>
        ) : null}
      </Grid>
    </Page>
  )
}

export const EventRosterView = compose(
  withTranslation(),
  injectIntl,
)(EventRosterViewComponent)
